// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  contentHash: __t.string(),
  kind: __t.string(),
  name: __t.string(),
  sourceUri: __t.string(),
  polyCount: __t.u32(),
  textureCount: __t.u16(),
  materialCount: __t.u16(),
  sizeBytes: __t.u64(),
  vramEstimateMb: __t.u32(),
  geometryCodec: __t.string(),
  textureCodec: __t.string(),
  license: __t.string(),
};
